import * as constants from '../constants/constants';

const defaultStore = {
  allTags: [],
  choosedTags: [],
  allRecipeTags: [],
  products: [],
  tagsCategories: [],
  allEatingTags: [],
  isSearchProductLoading: false,
  isSearchDishLoading: false,
  currentProduct: [],
  currentTraining: {},
  currentDish: {},
  dishes: [],
  numberOfLinkedRecipes: 0,
  usersGeneratedData: [],
  userTarget: [],
  users: [],
  productToFind: [],
  complexity: [],
  trainingType: [],
  trainingGears: [],
  trainingTemplate: [],
  trainingTemplateId: {},
  marathonsList:[],
  marathonData: {},
  userMenuMarathon: [],
  isDishLoading: false,
  isProductLoading: false,
  isTrainingLoading: false,
  training: [],
  isVideoModalOpen: false,
  activeVideo: '',
  usersList: [],
  isUsersListLoading: false,
  userInfo: {
    courses: [
      {
        end_date: '',
        id: 0,
        is_paid: false,
        start_date: '',
      },
    ],
  },
  // userMenuInCourse: [],
  userMenuInCourse: [],
  userTrainingCourse: [],
  mealsToReplaceList: [],
  dishForReplacement: [],
  createCourseLoading: false,
};

export default (state = defaultStore, action) => {
  switch (action.type) {
    case constants.GET_NEW_YOUSLIM_TAGS:
      return {
        ...state,
        allTags: action.payload.allTags,
      };
    case constants.GET_NEW_YOUSLIM_RECIPE_TAGS:
      return {
        ...state,
        allRecipeTags: action.payload.allRecipeTags,
      };
    case constants.SET_NEW_YOUSLIM_PRODUCTS:
      return {
        ...state,
        products: action.payload.products,
      };
    case constants.SET_NEW_YOUSLIM_DISH:
      return {
        ...state,
        dishes: action.payload.dishes,
      };

    case constants.SET_TRAINING_SHOULD_DELETE:
      return {
        ...state,
        isTrainingDelete: action.payload.isTrainingDelete,
      };

    case constants.SET_TAGS_CATEGORIES:
      return {
        ...state,
        tagsCategories: action.payload.tagsCategories,
      };
    case constants.GET_NEW_YOUSLIM_EATING_TAGS:
      return {
        ...state,
        allEatingTags: action.payload.allEatingTags,
      };
    case constants.SET_SEARCH_PRODUCT_LOADING_STARTED:
      return {
        ...state,
        isSearchProductLoading: true,
      };
    case constants.SET_SEARCH_PRODUCT_LOADING_END:
      return {
        ...state,
        isSearchProductLoading: false,
      };
    case constants.SET_SEARCH_DISH_LOADING_STARTED:
      return {
        ...state,
        isSearchDishLoading: true,
      };
    case constants.SET_SEARCH_DISH_LOADING_END:
      return {
        ...state,
        isSearchDishLoading: false,
      };
    case constants.SET_CURRENT_PRODUCT:
      return {
        ...state,
        currentProduct: action.payload.product,
      };
    case constants.SET_CURRENT_DISH:
      return {
        ...state,
        currentDish: action.payload.dish,
      };
    case constants.GET_NUMBER_OF_LINKED_RECIPES:
      return {
        ...state,
        numberOfLinkedRecipes: action.payload.numberOfLinkedRecipes,
      };
    case constants.SET_GENERATOR_DATA:
      return {
        ...state,
        usersGeneratedData: action.payload.data,
      };
    case constants.SET_NEW_YOUSLIM_USER_TARGET:
      return {
        ...state,
        userTarget: action.payload.target,
      };
    case constants.SET_NEW_YOUSLIM_USER:
      return {
        ...state,
        users: action.payload.users,
      };
    case constants.SET_PRODUCT_TO_FIND:
      return {
        ...state,
        productToFind: action.payload.productToFind,
      };

    case constants.SET_COMPLEXITY:
      return {
        ...state,
        complexity: action.payload.complexity,
      };
    case constants.SET_TRAINING_TYPE:
      return {
        ...state,
        trainingType: action.payload.trainingType,
      };
    case constants.SET_TRAINING_GEARS:
      return {
        ...state,
        trainingGears: action.payload.trainingGears,
      };

    case constants.SET_TRAINING:
      return {
        ...state,
        training: action.payload.training,
      };

    case constants.SET_CURRENT_TRAINING:
      return {
        ...state,
        currentTraining: action.payload.currentTraining,
      };

    case constants.SET_TRAINING_TEMPLATE:
      return {
        ...state,
        trainingTemplate: action.payload.trainingTemplate,
      };

    case constants.SET_TRAINING_TEMPLATE_ID:
      return {
        ...state,
        trainingTemplateId: action.payload.trainingTemplateId,
      };
      
      case constants.SET_TRAINING_COURSE:
        return {
          ...state,
          userTrainingCourse: action.payload.userTrainingCourse,
        };
//marathon
        case constants.SET_MARATHONS_LIST:
          return {
            ...state,
            marathonsList: action.payload.marathonsList,
          };

          case constants.SET_MARATHON_DATA:
            return {
              ...state,
              marathonData: action.payload.marathonData,
            };

            case constants.SET_USER_MENU_MARATHON:
              return{
                ...state,
                userMenuMarathon: action.payload.userMenuMarathon,
              };

    case constants.SET_PRODUCT_LOADING:
      return {
        ...state,
        isProductLoading: true,
      };
    case constants.FINISH_PRODUCT_LOADING:
      return {
        ...state,
        isProductLoading: false,
      };
    case constants.SET_DISH_LOADING:
      return {
        ...state,
        isDishLoading: true,
      };
    case constants.FINISH_DISH_LOADING:
      return {
        ...state,
        isDishLoading: false,
      };
    case constants.SET_TRAINING_LOADING:
      return {
        ...state,
        isTrainingLoading: true,
      };
    case constants.FINISH_TRAINING_LOADING:
      return {
        ...state,
        isTrainingLoading: false,
      };

    case constants.NEW_SET_IS_VIDEO_MODAL_OPEN:
      return {
        ...state,
        isVideoModalOpen: action.payload.isVideoModalOpen,
      };
    case constants.NEW_SET_ACTIVE_VIDEO:
      return {
        ...state,
        activeVideo: action.payload.activeVideo,
      };
    case constants.SET_USERS_LIST:
      return {
        ...state,
        usersList: action.payload.usersList,
      };
    case constants.SET_USERS_LIST_LOADING:
      return {
        ...state,
        isUsersListLoading: true,
      };
    case constants.FINISH_USERS_LIST_LOADING:
      return {
        ...state,
        isUsersListLoading: false,
      };
    case constants.SET_NEW_YOUSLIM_USER_INFO:
      return {
        ...state,
        userInfo: action.payload.user,
      };
    case constants.SET_USERS_LIST_FOR_SELECT:
      return {
        ...state,
        usersListForSelect: action.payload.usersListForSelect,
      };

    case constants.SET_UPDATE_USER_IS_PAID:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          courses: state.userInfo.courses.map((course, index) => {
            if (index === action.payload.index) {
              return { ...course, is_paid: action.payload.is_paid };
            }
            return course;
          }),
        },
      };

    case constants.SET_UPDATE_USER_START_DATE:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          courses: state.userInfo.courses.map((course, index) => {
            if (index === action.payload.index) {
              return { ...course, start_date: action.payload.start_date };
            }
            return course;
          }),
        },
      };
    case constants.SET_UPDATE_USER_STATUS_COURSE:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          courses: state.userInfo.courses.map((course, index) => {
            if (index === action.payload.index) {
              return {
                ...course,
                status_course: {
                  id: 1,
                  name: 'Active',
                },
              };
            }
            return course;
          }),
        },
      };

    case constants.SET_UPDATE_MENU_IN_COURSE:
      return {
        ...state,
        userMenuInCourse: action.payload.userMenuInCourse,
      };
    case constants.SET_MEALS_TO_REPLACE_LIST:
      return {
        ...state,
        mealsToReplaceList: action.payload.mealsToReplaceList,
      };
    case constants.SET_DISH_FOR_REPLACEMENT:
      return {
        ...state,
        dishForReplacement: action.payload.dishForReplacement,
      };
    case constants.SET_CREATE_COURSE_LOADING:
      return {
        ...state,
        createCourseLoading: true,
      };
    case constants.FINISH_CREATE_COURSE_LOADING:
      return {
        ...state,
        createCourseLoading: false,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/newYouslim.js